import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import functions from '../../util/functions';
import ajaxUser from '../../util/remote/ajaxUser';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import PageHeader from '../../components/Nav/PageHeader';
import { useAuth } from '../../DataStore/AuthContext';
import { useClearState } from '../../DataStore/useClearState';
import MainLayout from '../../layouts/MainLayout';
import OrgProfileCard from '../../components/Central/OrgProfileCard';

const ProfileSwitchPage = () => {

    const {connectedProfiles, getProfiles, activeProfile, getCentralUser, centralUser } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const tokenInfo = functions.readUser();

    useEffect(()=>{
        getProfiles();
        getCentralUser();
    }, [])

    useEffect(()=>{
        if(activeProfile){
            navigate('/');
        }
    }, [activeProfile]);

    const clearAllState = useClearState();

    if (!tokenInfo) {
        return <Navigate to="/login" />;
    }

    const handleLogout = ()=>{
        // Clear all states and remove token
        clearAllState();
        localStorage.removeItem('ofc');
        navigate('/login');
        window.location.reload();
    }


    const handleOrgClick = async(org_id) => {
        if(loading){
            return;
        }
        setLoading(true);
        const server_response = await ajaxUser.switchProfiles(org_id);
        setLoading(false);
        if(server_response.status === "OK"){
            navigate('/dashboard')
            window.location.reload();
        }

    };

    return (
    <MainLayout>
        <PageHeader
          title="Business Profiles"
          breadcrumb={
            <li className="breadcrumb-item active" aria-current="page">
              Business Profiles
            </li>
          }
          primaryButtons={[
            {
              label: 'Create Profile',
              icon: 'fas fa-plus',
              className: 'btn-success',
              onClick: ()=>navigate('/profile-create')
            }
          ]}
          dropdown={{
            label: 'Options',
            icon: 'fas fa-cog',
            items: [
              { label: 'Refresh', icon: 'fas fa-sync', onClick: () => getProfiles(true) },
              { label: 'Logout', icon: 'fas fa-sign-out-alt', onClick: handleLogout },
            ]
          }}
        />

         <div className="col-lg-8 mb-4 pr-4">
            <h1 className="display-5 mb-1">
                <span className='thin-text'>Welcome</span> <span className="text-success thin-text">{centralUser?.first_name}!</span>
            </h1>
            <p className="lead mb-0 text-12">All your OpenFi Business Profiles are listed under. You can choose to manage an existing
                profile by being invited using {tokenInfo.username} or create your own public <b>hotspot business</b> by clicking 'Create Profile' on your right.</p>
          </div>


             <div className="organization-tiles m-5">
                            {!loading && Array.isArray(connectedProfiles) &&  connectedProfiles.map((org) => <OrgProfileCard key={org.org_id} org={org} handleOrgClick={handleOrgClick} />)}
                            {(!connectedProfiles || loading) && <ActivityLoader />}
                        </div>
            {connectedProfiles === "404" && <Notification type="info" message="No connected company profiles were found" closable={false} />}


       

  </MainLayout>
    );
};

export default ProfileSwitchPage;
